import React from "react";
import { Box, Typography } from "@mui/material";
import { formatCurrencyManual } from "../../utils/formatters";
import { FormCard } from "../../components/ui/form";
import { Num } from "../../components/ui";
import { tokens } from "../../theme";

/** Dato del cliente: etiqueta chica arriba, valor abajo. Apila solo en teléfono. */
const ClientFact = ({ label, children, numeric }) => (
  <Box sx={{ display: "flex", flexDirection: "column", gap: "2px", minWidth: 0 }}>
    <Typography sx={{ fontSize: "11.5px", fontWeight: 500, color: tokens.ink3 }}>
      {label}
    </Typography>
    {numeric ? (
      <Num sx={{ fontSize: "14px", fontWeight: 600 }}>{children}</Num>
    ) : (
      <Typography
        sx={{
          fontSize: "14px",
          fontWeight: 600,
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {children}
      </Typography>
    )}
  </Box>
);

/**
 * Encabezado de la cuenta corriente del cliente.
 *
 * Misma tarjeta que el encabezado de Recibos, con los datos propios de esta
 * pantalla: acá no se carga una observación, se muestra cuánto se debe.
 */
const HeadPayment = ({ client, totalTickets, totalDue }) => {
  return (
    <FormCard
      title="Cuenta corriente"
      subtitle="Facturas adeudadas"
      sx={{ width: "100%", minWidth: 0 }}
    >
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "minmax(0, 1fr)", sm: "repeat(auto-fit, minmax(190px, 1fr))" },
          gap: { xs: "12px", md: "16px" },
        }}
      >
        <ClientFact label="Cliente">{client ? client.company : "No disponible"}</ClientFact>
        <ClientFact label="Facturas adeudadas" numeric>
          {totalTickets > 0 ? totalTickets : 0}
        </ClientFact>
        <ClientFact label="Total adeudado" numeric>
          {formatCurrencyManual(totalDue || 0)}
        </ClientFact>
        <ClientFact label="Saldo disponible" numeric>
          {formatCurrencyManual(client ? client.balance : 0)}
        </ClientFact>
      </Box>
    </FormCard>
  );
};

export default HeadPayment;
